<div
	#captionContainerElRef
	class="inner"
	[ngClass]="{
		'noBorderRadiusRight': isContentOverflowing(),
		'inner--hidden': !feedbackItem
	}">
	<div *ngIf="feedbackItem" class="comment-caption">
		<span>
			<strong class="comment-creator-name">{{ feedbackItem.fullname }}</strong>
			<span class="comment-tag" *ngFor="let tag of feedbackItem.markers">
				<marker [marker]="tag" [aiStyle]="feedbackItem.was_ai_generated"></marker>
			</span>
			<span class="comment-caption-text" [innerHTML]="feedbackItem.text | sanitize"></span>
			<span *ngIf="feedbackItem.media.length" translate="feedback-session-comment-captions_media-comment"></span>
		</span>
	</div>
</div>
